import { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import TableComponent from "./../../components/TableComponent";
import SearchBox from "./../../components/SearchComponent";
import DateRangeSelector from "./../../../Common/DateRangeElement";
import { formatDate, isValidObject, reverseDateFormat, exportPurchaseReport } from "./../../../utils";
import { headerColumn } from "./../../../constants";
import { getPurchaseInv } from "../../../actions/inventory";
import SearchableDropdown from "../../../Common/SearchDropdown";
import PurchaseDetails from "./PurchaseDetails";
import ButtonElement from "../../../Common/ButtonElement";
import { toast } from "react-toastify";

const Purchase = () => {
    const [state, setState] = useState({
        purchases: [],
        loading: false,
        search: "",
        supplier: "",
        status: "",
        current: 1,
        total: 1,
        purchaseData: null,
        selectedRange: { startDate: null, endDate: null }
    });
    const { filters, userData } = useSelector(({ inventory, userDetails }) => ({
        filters: inventory.filters,
        userData: userDetails.data,
    }), shallowEqual);
    const { purchases, supplier, loading, current, total, search, supplierId, purchaseData, selectedRange } = state;

    const getPurchases = (isDownload) => {
        let query = `?page=${current}&limit=200`;
        if(isDownload) query = `${query}&isDownload=1`;
        if (search) query = `${query}&keyword=${search}`;
        if (selectedRange?.startDate && selectedRange?.endDate) query = `${query}&startDate=${reverseDateFormat(selectedRange?.startDate ?? "")}&endDate=${reverseDateFormat(selectedRange?.endDate ?? "")}`;
        if (supplier) query = `${query}&supplierId=${supplierId}`;

        if(!isDownload) setState(prev => ({ ...prev, loading: true }));
        getPurchaseInv(query).then(response => {
            const { data, meta } = response.data;
            if (isValidObject(data)) {
                const list = data ?? [];
                if(isDownload) downloadPurchaseData(list);
                else setState(prev => ({ ...prev, purchases: list, total: meta?.total ?? 1 }));
            }
        }).catch(ex => { }).finally(() => setState(prev => ({ ...prev, loading: false })))
    }

    const downloadPurchaseData = (list) => {
        if (!list || list.length === 0) {
            toast.error("No data available to download")
            return;
        }

        // Company name from Redux user data
        const companyName = userData?.dealerName || userData?.name || "";

        const fileLabel = `purchase-report-${formatDate(new Date())}`;

        exportPurchaseReport(list, fileLabel, companyName); //
    }

    const paginationAction = (pageIndex) => {
        setState(prev => ({ ...prev, current: pageIndex }));
        getPurchases(null)
    }

    const onSelectHandler = (key, value) => {
        setState(prev => ({ ...prev, [key]: value?.name ?? "", [`${key}Id`]: value?.id ?? null }));
    }

    useEffect(() => {
        paginationAction(1);
    }, [search, supplier, current, selectedRange])

    return <div className="inventory-container purchase purchase-table-no-height">
        {/* <SearchBox placeholder="Search here..." className="mb-3" value={search} onChange={(e) => setState(prev => ({ ...prev, search: e.target.value }))} /> */}
        <TableComponent col={4} breakPoint="lg" title={"Purchase Inventory"} headers={headerColumn.purchase} data={purchases} current={current} total={total} tableLoading={loading} paginationAction={paginationAction} render={(tdData, index) => <tr className="cursor-pointer" key={index} onClick={() => setState(prev => ({...prev, purchaseData: tdData?.totalcount ? tdData ?? null : null }))}>
            <td>{(index ?? 0) + 1}</td>
            <td>{formatDate(tdData?.invoice_date ?? "")}</td>
            <td>{tdData?.invoice_number ?? "-"}</td>
            <td>{tdData?.supplier_name ?? "-"}</td>
            <td><div style={{ maxWidth: "150px"}}>{
                <>
                    <p className="mb-0">{tdData?.totalcount ?? "-"}</p>
                    {tdData?.totalcount ? <p className="text-start text-wrap mb-0" style={{lineHeight: "14px"}}>
                        {Object.entries(tdData?.type_counts).map((item, index) => {
                            return <span className="me-1" style={{ fontSize: "10px", color: "grey" }} key={index}>{item[0]} : {item[1]}{(Object.keys(tdData?.type_counts).length - 1 != index) ? "," : ""}</span>
                        })}
                    </p> : null}
                </>}
            </div></td>
            <td>{formatDate(tdData?.created_at ?? "")}</td>
        </tr>} FilterComponent={<div className="d-flex justify-content-end">
            <div className="me-2">
                <SearchableDropdown
                    placeholder={"Supplier Name"}
                    value={supplier}
                    error={false}
                    options={filters?.suppliers ?? []}
                    onSelect={(value) => onSelectHandler("supplier", value)}
                />
            </div>
            <DateRangeSelector updateRange={(date) => setState(prev => ({...prev, selectedRange: {...date} }))} />
            <ButtonElement text={"Download Excel"} cssClass="small-radius me-1 ms-1 mb-1" onClick={() => getPurchases(true)} variant="btn-black" />
        </div>} />

        {purchaseData ? <PurchaseDetails data={purchaseData} hideModal={() => setState(prev => ({...prev, purchaseData: null}))} /> : null}
    </div>
}

export default Purchase;